import { VPStages } from '../../../Components/SellToUs/enums/stage.enums';

/**
 * A list of parameters that can be used to filter the items in the SellToUs component.
 *
 * @constant
 * @type {Array}
 * @property {Object} stage - The stage of the item.
 */
export const possibleParams = [
  {
    field: 'stage',
    type: 'string' as const,
    values: [
      VPStages.PENDING_FN,
      VPStages.NEEDS_DETAILS,
      VPStages.DETAILS_SENT,
      VPStages.PO_CREATED,
      VPStages.PASSED,
    ] as const,
  },
  {
    field: 'search',
    type: 'string' as const,
    optional: true,
  },
  {
    field: 'category',
    type: 'array' as const,
    optional: true,
  },
  {
    field: 'class',
    type: 'array' as const,
    optional: true,
  },
] as const;
